{
  "title": "Kaverit",
  "playingNow": "Kaverit pelaavat nyt",
  "viewAll": "Näytä kaikki",
  "score": "Tulos",
  "toPar": "Pariin",
  "handicap": "Tasoitus",
  "noFriends": "Sinulla ei ole vielä kavereita. Aloita lisäämällä sähköpostilla tai QR-koodilla.",
  "searchDescription": "Lähetä kaveripyyntö sähköpostiosoitteella.",
  "searchPlaceholder": "Sähköposti...",
  "sendRequest": "Lähetä pyyntö",
  "requestSent": "Kaveripyyntö lähetetty onnistuneesti!",
  "sentRequests": "Lähetetyt pyynnöt",
  "accept": "Hyväksy",
  "decline": "Hylkää",
  "cancelRequest": "Peruuta pyyntö",
  "removeFriend": "Poista kaveri",
  "removeFriendTitle": "Poista kaveri",
  "blockUser": "Estä käyttäjä",
  "blockUserTitle": "Estä käyttäjä",
  "confirmRemove": "Haluatko varmasti poistaa käyttäjän {{name}} kavereistasi?",
  "confirmBlock": "Haluatko varmasti estää käyttäjän {{name}}? Tämä poistaa hänet kavereistasi ja estää häntä lähettämästä sinulle pyyntöjä.",
  "tabs": {
    "myFriends": "Kaverit",
    "findFriends": "Etsi",
    "qrConnect": "QR"
  },
  "sections": {
    "requests": "Kaveripyynnöt",
    "friends": "Kaverit"
  },
  "qr": {
    "title": "Kaverin QR-koodi",
    "scanTitle": "Skannaa QR-koodi",
    "description": "Yhdistä kavereihin henkilökohtaisesti luomalla QR-koodi tai skannaamalla heidän koodinsa.",
    "generateCode": "Luo QR-koodini",
    "scanCode": "Skannaa kaverin QR-koodi",
    "instructions": "Näytä tämä QR-koodi kaverillesi yhdistääksesi välittömästi.",
    "scanInstructions": "Aseta QR-koodi kehyksen sisään skannataksesi.",
    "usesRemaining": "Käyttöä jäljellä",
    "expiresAt": "Vanhenee",
    "generating": "Luodaan QR-koodia...",
    "processing": "Käsitellään...",
    "generateError": "QR-koodin luominen epäonnistui. Yritä uudelleen.",
    "cameraError": "Kameraan ei saada yhteyttä. Tarkista käyttöoikeudet.",
    "acceptError": "Kaveripyynnön hyväksyminen epäonnistui. Koodi saattaa olla vanhentunut.",
    "tryAgain": "Yritä uudelleen"
  },
  "scorecard": {
    "course": "Kenttä",
    "teeSet": "Tii",
    "started": "Aloitettu",
    "loadError": "Kaverin tuloskortin lataaminen epäonnistui. Sinulla ei ehkä ole oikeutta katsoa sitä.",
    "backToFriends": "Takaisin kavereihin",
    "autoRefresh": "Päivittyy automaattisesti 2 minuutin välein"
  },
  "profile": {
    "roundsLabel": "Kierrosta",
    "averageLabel": "Tuloskeskiarvo",
    "bestLabel": "Paras kierros",
    "recentRounds": "Viimeisimmät kierrokset",
    "noClub": "Ei seuraa",
    "showMore": "Näytä lisää",
    "noRounds": "Ei kierroksia vielä",
    "loadError": "Kaverin profiilin lataaminen epäonnistui.",
    "notFound": "Kaveria ei löytynyt.",
    "removeError": "Kaverin poistaminen epäonnistui.",
    "blockError": "Käyttäjän estäminen epäonnistui.",
    "partialLoadError": "Kaikkia tietoja ei voitu ladata."
  }
}
